import axiosTokenInstance from "services/api/backoffice";
import {
    CHECK_PAYMENT_STATUS,
    CHECK_PAYMENT_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const getCheckPaymentStatus = (params) => async (dispatch) => {
    const { lead_id } = params || {};

    const dispatchObj = {
        method: "get",
        status: undefined,
        payload: undefined,
        type: undefined,
    };

    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/leads/${lead_id}/payment-status`
        );

        const { data, status } = response || {};

        dispatchObj.type = CHECK_PAYMENT_STATUS;
        dispatchObj.status = status || {};
        dispatchObj.payload = data || {};

        dispatch(dispatchObj);
    } catch (e) {
        console.error(e);

        const { response } = e || {};
        const { data, status } = response || {};

        dispatchObj.type = CHECK_PAYMENT_STATUS_ERROR;
        dispatchObj.status = status || {};
        dispatchObj.payload = data || {};

        dispatch(dispatchObj);
    }
};
